// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cesium-panel[data-v-bea80b5a]{margin-right:5px;pointer-events:auto}#imgNord[data-v-bea80b5a]{height:60px;position:absolute;top:15%;right:5px}", ""]);
// Exports
module.exports = exports;
